module.exports = __webpack_public_path__ + "img/signupsidebanner-bg.f5de3d03.jpg";